// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"07e2f165","280":"97a2a582"}[chunkId] + ".chunk.js";
};